/**
 * get CBT policy for flight rands details request
 */
import getCbtClient, { cbtResponse } from "shared/cbt/cbtClient";
import golApiCall from "shared/gol-api/golApiCall";

import { findAndRemoveKeyFromObj } from "../../lib/functions";

const createRequest = (refs: string[]) => {
  return {
    GolApi: {
      RequestDetail: {
        BrandsDetailsRequest_1: {
          SearchedReferences: {
            Reference: refs.map((oRef) => ({ $t: oRef })),
          },
        },
      },
    },
  };
};

type Params = {
  cbtToken: string;
  customerUsername: string;
  cbtApiUrl: string;
  flightRefs: string[];
  costCenterId: string;
  guests: number;
  travelReasonId: string;
  userIds: string[] | string;
  tripType: string;
};

const brandsDetailsCbt = async ({
  cbtToken,
  customerUsername,
  cbtApiUrl,
  flightRefs,
  costCenterId,
  guests,
  travelReasonId,
  userIds,
  tripType,
}: Params) => {
  if (!cbtToken) return;

  const flightRefResponse = await golApiCall(createRequest(flightRefs));

  if (flightRefResponse.ResponseDetail.BrandsDetailsError_1) {
    return {
      success: false,
      errorMsg:
        flightRefResponse.ResponseDetail.BrandsDetailsError_1.Error[0].$t,
    };
  }

  flightRefResponse.ResponseDetail.BrandsDetailsResponse_1.FlightOffers = [
    {
      FlightOffer:
        flightRefResponse.ResponseDetail.BrandsDetailsResponse_1?.FlightOffers
          ?.FlightOffer,
    },
  ];

  const lowestPrice =
    flightRefResponse.ResponseDetail.BrandsDetailsResponse_1.FlightOffers[0]
      .FlightOffer[0].PricingDetails.PricingDetail[0].FlightPricing.FlightPrice
      .DisplayPricePerPassenger;

  const UserIds = userIds ? (Array.isArray(userIds) ? userIds : [userIds]) : [];

  const filteredResp = findAndRemoveKeyFromObj(flightRefResponse, [
    "References",
    "BrandServices",
  ]);

  const requestBody = {
    UserIds,
    Guests: Number(guests),
    TravelReasonId: travelReasonId,
    CostCenterId: costCenterId,
    TripType: tripType,
    LowestPrice: Number(lowestPrice),
    GolApiResponse: filteredResp,
  };

  const cbtClient = await getCbtClient({
    cbtToken,
    customerUsername,
    cbtApiUrl,
  });

  const request = cbtClient.post(
    `/policies/resolve-gol-api-brands-details`,
    requestBody
  );

  return cbtResponse(request);
};

export default brandsDetailsCbt;
